import { ClosingProperties } from "./closing.type";
import { EmailPortal, EmployeeProperties } from "./employee.type";
import { CustomPhotosItem, FileProperties } from "./file.type";
import { ListingCertificateTypeProperties } from "./listingCertificateType.type";
import { ListingPartProperties } from "./listingPart.type";
import { ListingPropertyTypeProperties } from "./listingPropertyType.type";
import { ListingRenewHistoryProperties } from "./listingRenewHistory.type";
import { ListingTransferHistoryProperties } from "./listingTransferHistory.type";
import { OfficeProperties } from "./office.type";
import { PortalListingProperties, PortalListingSyncProperties } from "./portalListing.type";
import { OfficePortalProfileProps } from "./portalProfile.type";
import { ProfileProperties } from "./profile.type";
import { UserProperties } from "./user.type";

export const LISTING_STATUS_COLOR = {
	PUBLISH: "#366CF4",
	CLOSED: "#4CCA85",
	UNPUBLISH: "#99A2BA",
	EXPIRED: "#FFBD52",

	PUBLISH_OPACITY: "rgba(54, 108, 244, 0.5)",
	CLOSED_OPACITY: "rgba(76, 202, 133, 0.5)",
	UNPUBLISH_OPACITY: "rgba(153, 162, 186, 0.7)",
	EXPIRED_OPACITY: "rgba(255, 189, 82, 0.5)",
};

export interface ListingFacilityItem {
	facilityName: string;
	total: number;
}
export enum EListingSellOrRent {
	SELL = "sell",
	RENT = "rent",
}
export enum EListingType {
	SECONDARY = "secondary",
	PRIMARY = "primary",
}
export enum EListingStatus {
	OPEN = "OPEN",
	PUBLISH = "PUBLISH",
	WAITING_APPROVAL = "WAITING_APPROVAL",
	UNPUBLISH = "UNPUBLISH",
	PENDING = "PENDING",
	CLOSED = "CLOSED",
	EXPIRED = "EXPIRED",
	REJECTED = "REJECTED",
}

export enum EListingBuildingFace {
	NORTH = "north",
	EAST = "east",
	SOUTH = "south",
	WEST = "west",
	NORTHEAST = "northeast",
	SOUTHEAST = "southeast",
	NORTHWEST = "northwest",
	SOUTHWEST = "southwest",
}

export interface ListingAdditionalPriceFreq {
	daily?: number;
	monthly?: number;
	yearly?: number;
}
export enum EDefaultPriceFreq {
	daily = "daily",
	monthly = "monthly",
	yearly = "yearly",
}
export enum EListingPDFOrientation {
	PORTRAIT = "PORTRAIT",
	LANDSCAPE = "LANDSCAPE",
}
export enum EPortalListingResultStatus {
	processing = "processing",
	completed = "completed",
	failed = "failed",
	rejected = "Rejected",
	Completed = "Completed",
}
export interface ListingSellerAddressProperties {
	country: string;
	province: string;
	city: string;
	postalCode: string;
	streetName: string;
	blokNumber: string;
	houseNumber: string;
}
export interface BaseListingProperties {
	listingId: string;
	listingCode?: string;
	userId?: string;
	employeeId?: string;
	officeId?: string;
	sellerName?: string;
	sellerPhone?: string;
	sellerEmail?: string;
	sellerAddress?: ListingSellerAddressProperties;
	sellerMartialStatus?: string;
	sellerKtpNumber?: string;
	title?: string;
	photos?: (CustomPhotosItem | { error: any })[];
	videoUrl?: string[];
	description?: string;
	country?: string;
	province?: string;
	city?: string;
	district?: string;
	postalCode?: string;
	streetName?: string;
	blokName?: string;
	houseNumber?: string;
	latitude?: number;
	longitude?: number;
	sellOrRent?: EListingSellOrRent;
	listingType?: EListingType;
	listingPartId?: string;
	listingPropertyTypeId?: string;
	listingCertificateTypeId?: string;
	buildingArea?: number;
	landArea?: number;
	buildingFace?: EListingBuildingFace;
	numberOfFloor?: number;
	mainBedroom?: number;
	mainBathroom?: number;
	housekeepBedroom?: number;
	housekeepBathroom?: number;
	facilities?: ListingFacilityItem[];
	price?: number;
	additionalPriceFreq?: ListingAdditionalPriceFreq;
	defaultPriceFreq: EDefaultPriceFreq;
	status: EListingStatus;
	expiredAt?: Date;
	pdfOrientation: EListingPDFOrientation;
	createdByUserId?: string;
	createdByUserMeta?: any;
	emailPortals?: EmailPortal[];
	createdAt: Date;
	updatedAt: Date;
	rumah123_officePortalProfileId?: string | null;
	rumah123_agentPortalProfileId?: string | null;
	lamudi_officePortalProfileId?: string | null;
	lamudi_agentPortalProfileId?: string | null;

	copyListingMaskingCount?: string;
	pdfListingMaskingCount?: string;
	listingMaskingCountByAgent?: string;
	maskingCount: number;
}
export interface ListingProperties extends BaseListingProperties {
	profile?: ProfileProperties;
	user?: UserProperties;
	employee?: EmployeeProperties;
	office?: OfficeProperties;
	listingPart?: ListingPartProperties;
	listingCertificateType?: ListingCertificateTypeProperties;
	listingPropertyType?: ListingPropertyTypeProperties;
	listingTransferHistory?: ListingTransferHistoryProperties[];
	listingRenewHistory?: ListingRenewHistoryProperties[];
	portalListing?: PortalListingProperties[];
	closing?: ClosingProperties[];
	portalListingSyncs?: PortalListingSyncProperties[];

	sellerKtpFile?: FileProperties;

	rumah123_officePortalProfile?: OfficePortalProfileProps;
	lamudi_officePortalProfile?: OfficePortalProfileProps;

	rumah123_agentPortalProfile?: OfficePortalProfileProps;
	lamudi_agentPortalProfile?: OfficePortalProfileProps;
}

export interface ListingPhotoUploadResponse {
	key: string;
	url: string;
	originalName: string;
	mimeType: string;
}

export interface ListListingQuery {
	filterEmployeeId?: string;
	filterOfficeId?: string;
	filterUserId?: string;
	filterCountry?: string;
	filterProvince?: string;
	filterCity?: string;
	filterPostalCode?: string;
	filterSellOrRent?: string;
	filterListingType?: string;
	filterListingPartId?: string;
	filterListingPropertyTypeId?: string;
	filterListingCertificateTypeId?: string;
	filterBuildingFace?: string;
	filterStatus?: string | string[];
	filterCreatedByUserId?: string;
	includeData?: string;
	sort?: string;
	isSmartSearch?: string;
	excludeUserId?: string;
	excludeListingId?: string;
	filterCreatedAtStartAt?: string;
	filterCreatedAtEndAt?: string;
	filterPublishAtStartAt?: string;
	filterPublishAtEndAt?: string;
	filterSWLatitude?: number;
	filterSWLongitude?: number;
	filterNELatitude?: number;
	filterNELongitude?: number;
	filterIsListingMapNotSet?: string;
}

export interface ListListingMaskingQuery {
	filterOfficeId?: string;
	filterUserId?: string;
	filterMaskingByAgent?: string;
	filterListingAgent?: string;
	filterStatusListing?: string;
	filterType?: string;
	includeData?: string;
}

export interface ListingStatusStatisticItems {
	publish: number;
	unpublish: number;
	closed: number;
	expired: number;
}
export interface ListingMonthlyStatusStatisticItem {
	currentMonth: ListingStatusStatisticItems;
	prevMonth: ListingStatusStatisticItems;
}
export interface ListingStatusStatisticResponse {
	current: ListingStatusStatisticItems;
	monthlyStatus: ListingMonthlyStatusStatisticItem;
}

export interface PortalListingResultDto {
	portalListingId: string;
	link?: string;
	status: EPortalListingResultStatus;
	message?: string;
}
